import { graphql } from 'gatsby';
import React from 'react';

interface VideoBlockProps {
  max_width: string;
  url: string;
}

const VideoBlock: React.FC<VideoBlockProps> = ({ max_width, url }) => {
  const [isPlaying, setIsPlaying] = React.useState(false);
  const container = React.useRef<HTMLVideoElement | null>(null);

  const start = () => {
    if (container.current) {
      const playPromise = container.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setIsPlaying(true);
          })
          .catch(() => {
            console.warn('Playback prevented by browser. User must interact with the page or video element first.');
          });
      }
    }
  };

  const stop = () => {
    if (container.current) {
      setIsPlaying(false);
      container.current.pause();
    }
  };

  const togglePlaying = () => {
    setIsPlaying(!isPlaying);
  };

  const toggleTouchPlaying = () => {
    if (isPlaying) {
      stop();
    } else {
      start();
    }
  };

  return (
    <div className='block__video'>
      <div className={`video-block ${max_width}`}>
        <div
          className={`play-icon play-icon--${isPlaying ? 'playing' : 'paused'}`}
          onClick={start}
        >
          <div className='play-icon__icon' />
        </div>
        <video
          controls
          onClick={togglePlaying}
          onTouchStart={toggleTouchPlaying}
          ref={container}
        >
          <source
            src={url}
            type='video/mp4'
          />
          <source
            src={url}
            type='video/mov'
          />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default VideoBlock;

export const videoBlockFragment = graphql`
  fragment VideoBlockFragment on Block {
    max_width
    url
  }
`;
